/* One media at a time: starting any <video>/<audio> pauses every other one (capture phase, 'play' doesn't bubble). */
(function(){
document.addEventListener('play',function(e){
  var t=e.target;
  if(!t||!/^(VIDEO|AUDIO)$/.test(t.tagName))return;
  [].forEach.call(document.querySelectorAll('video,audio'),function(m){if(m!==t&&!m.paused)m.pause()});
},true);
})();
